"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspace = void 0;
// [Workspace]
exports.workspace = function (axios) {
    return {
        getWorkspaceManagersMe: function () {
            return axios.get('/managers/me');
        },
        getWorkspaceManagersSimpleMalls: function () {
            return axios.get('/managers/simple-malls');
        },
        postAdminsTempWorkspace: function (request) {
            return axios.post('/admins/temp', request.data);
        },
    };
};
